import type { ReactNode } from 'react';
import { Helmet } from 'react-helmet';

/** Defense-in-depth metadata for internal/product/demo routes. */
const NoIndexRoute = ({ children }: { children: ReactNode }) => (
  <>
    <Helmet>
      <meta name="robots" content="noindex,nofollow,noarchive" />
    </Helmet>
    {children}
  </>
);

export default NoIndexRoute;
